import React from 'react';
import { AuthenticationProvider } from './useAuthentication';
import { UserProfileProvider } from './useUserProfile';

export default function wrapRootElement({ element }) {
  return (
    <AuthenticationProvider>
      <UserProfileProvider>{element}</UserProfileProvider>
    </AuthenticationProvider>
  );
}
